export * from "./DialogCard";
